'use client'
import {Chip} from '@heroui/react'
import Link from 'next/link'
import React, {useEffect, useState} from 'react'
import {usePathname} from 'next/navigation'
import {useSession} from 'next-auth/react'

import Icon from '@/components/UI/Icon/Icon'
import Box from '@/components/UI/Box/Box'

import {getUnreadMessagesCount} from '@/src/services/MessagesService/service'

const NavMessages = () => {
  const {status} = useSession()
  const [undreadMessagesCount, setUndreadMessagesCount] = useState<number>(0)
  const pathname = usePathname()

  useEffect(() => {
    if (status === 'authenticated') {
      getUnreadMessagesCount().then(setUndreadMessagesCount)
    }
  }, [status, pathname])

  return (
    <Link href="/hesabim/mesajlarim" aria-label="Go to messages page">
      <Box className="flex items-center justify-center relative">
        {undreadMessagesCount > 0 && (
          <Chip
            color="primary"
            classNames={{content: 'p-0 text-xxs leading-3 w-fit text-center'}}
            className="absolute -top-[2px] -right-[2px] max-w-none w-3 h-3 leading-3 text-white p-0">
            {undreadMessagesCount}
          </Chip>
        )}
        <Icon name="message" size={24} className="fill-primary" />
      </Box>
    </Link>
  )
}

export default NavMessages
